import { createActionGroup, props } from '@ngrx/store';
import { Tenant } from '@niko-crm/ui';
import { PaginatedResult } from '@niko-crm/ui';

export const TenantActions = createActionGroup({
  source: 'admin-Tenants',
  events: {
    'Load Tenants': props<{ page: number; limit: number }>(),
    'Load Tenants Success': props<{ result: PaginatedResult<Tenant> }>(),
    'Load Tenants Failure': props<{ error: string }>(),
    'Load Active Tenants': props<Record<string, never>>(),
    'Load Active Tenants Success': props<{ tenants: Tenant[] }>(),
    'Load Active Tenants Failure': props<{ error: string }>(),
    'Create Tenant': props<{ payload: Partial<Tenant> }>(),
    'Create Tenant Success': props<{ tenant: Tenant }>(),
    'Create Tenant Failure': props<{ error: string }>(),
    'Update Tenant': props<{ id: string; payload: Partial<Tenant> }>(),
    'Update Tenant Success': props<{ tenant: Tenant }>(),
    'Update Tenant Failure': props<{ error: string }>(),
    'Deactivate Tenant': props<{ id: string }>(),
    'Deactivate Tenant Success': props<{ id: string }>(),
    'Deactivate Tenant Failure': props<{ error: string }>(),
  },
});
